import { schema } from 'normalizr';

export const twilioNumberSchema = new schema.Entity(
  'twilioNumber',
  {},
  {
    idAttribute: 'phoneNumber',
  }
);
